import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Filiale } from '../../interface/Filiale';

export interface CatalogoSliceState {
  filialiList: Filiale[];
  filialiSelected: string[];
  tipoLentiList: {
    codiceFiliale: string;
    tipoLenti: string;
  }[];
  tipoLentiSelected: string[];
  tipoUtentiList: {
    codiceFiliale: string;
    utente: string;
  }[];
  tipoUtentiSelected: string[];
  tipoLineeList: {
    codiceFiliale: string;
    linea: string;
  }[];
  tipoLineeSelected: string[];
  confidenzialeActive: boolean;
  // Contatore incrementale: ogni incremento segnala a ImageList di ri-fetchare il catalogo
  catalogoVersion: number;
}

const initialState: CatalogoSliceState = {
  filialiList: [],
  filialiSelected: [],
  tipoLentiList: [],
  tipoLentiSelected: [],
  tipoUtentiList: [],
  tipoUtentiSelected: [],
  tipoLineeList: [],
  tipoLineeSelected: [],
  confidenzialeActive: false,
  catalogoVersion: 0,
};

export const CatalogoSlice = createSlice({
  name: 'catalogo',
  initialState,
  reducers: {
    setFilialiList(
      state: CatalogoSliceState,
      action: PayloadAction<Filiale[]>,
    ) {
      state.filialiList = action.payload;
    },
    setFilialiSelected(
      state: CatalogoSliceState,
      action: PayloadAction<string[]>,
    ) {
      state.filialiSelected = action.payload;
    },
    setTipoLentiList(
      state: CatalogoSliceState,
      action: PayloadAction<
        {
          codiceFiliale: string;
          tipoLenti: string;
        }[]
      >,
    ) {
      state.tipoLentiList = action.payload;
    },
    setTipoLentiSelected(
      state: CatalogoSliceState,
      action: PayloadAction<string[]>,
    ) {
      state.tipoLentiSelected = action.payload;
    },
    setConfidezialeActive(
      state: CatalogoSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.confidenzialeActive = action.payload;
    },
    setTipoUtentiList(
      state: CatalogoSliceState,
      action: PayloadAction<
        {
          codiceFiliale: string;
          utente: string;
        }[]
      >,
    ) {
      state.tipoUtentiList = action.payload;
    },
    setTipoUtentiSelected(
      state: CatalogoSliceState,
      action: PayloadAction<string[]>,
    ) {
      state.tipoUtentiSelected = action.payload;
    },
    setTipoLineeList(
      state: CatalogoSliceState,
      action: PayloadAction<
        {
          codiceFiliale: string;
          linea: string;
        }[]
      >,
    ) {
      state.tipoLineeList = action.payload;
      // Mantieni solo i marchi selezionati che esistono ancora nella nuova lista
      const validCodes = action.payload.map((item) => item.codiceFiliale);
      state.tipoLineeSelected = state.tipoLineeSelected.filter((code) =>
        validCodes.includes(code),
      );
    },
    setTipoLineeSelected(
      state: CatalogoSliceState,
      action: PayloadAction<string[]>,
    ) {
      state.tipoLineeSelected = action.payload;
    },
    resetCatalogoFilters(state: CatalogoSliceState) {
      state.filialiSelected = [];
      state.tipoLentiSelected = [];
      state.tipoUtentiSelected = [];
      state.tipoLineeSelected = [];
    },
    // Incrementa il contatore per triggerare un singolo refetch del catalogo
    incrementCatalogoVersion(state: CatalogoSliceState) {
      state.catalogoVersion += 1;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setFilialiList,
  setFilialiSelected,
  setTipoLentiList,
  setTipoLentiSelected,
  setTipoUtentiList,
  setTipoUtentiSelected,
  setTipoLineeList,
  setTipoLineeSelected,
  setConfidezialeActive,
  resetCatalogoFilters,
  incrementCatalogoVersion,
} = CatalogoSlice.actions;

export default CatalogoSlice.reducer;
